import React from "react";
import { KpiCard } from "../ui/KpiCard";

const OrderStatsCard = ({ title, value, percentage, loading, textValue = false }) => {
  const parsePct = (p) => {
    if (typeof p === "number") return p;
    if (p == null || p === "") return null;
    const n = parseFloat(String(p).replace("%", "").trim());
    return Number.isNaN(n) ? null : n;
  };

  const pct = parsePct(percentage);
  const trend = pct != null && pct < 0 ? "down" : "up";
  const displayPct = pct != null ? `${Math.abs(pct)}%` : percentage;

  return (
    <KpiCard
      title={title}
      value={value}
      percentage={displayPct}
      trend={trend}
      loading={loading}
      className={`h-100${textValue ? " oh-kpi-card--text-value" : ""}`}
    />
  );
};

export default OrderStatsCard;
